import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "text-dark order-2 order-md-1" }
const _hoisted_3 = { class: "text-muted fw-bold me-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://gannon.edu/",
  target: "_blank",
  class: "text-gray-800 text-hover-primary"
}, "Submit IRB ", -1)
const _hoisted_5 = { class: "menu menu-gray-600 menu-hover-primary fw-bold order-1" }
const _hoisted_6 = { class: "menu-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://irb.gannon.edu/#faq",
  target: "_blank",
  class: "menu-link px-2"
}, "About Us", -1)
const _hoisted_8 = { class: "menu-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://irb.gannon.edu/",
  target: "_blank",
  class: "menu-link px-2"
}, "About Us", -1)
const _hoisted_10 = { class: "menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, "Copyright © 2019-" + _toDisplayString(_ctx.currentYearDate()) + " All rights reserved |", 1),
        _hoisted_4
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_router_link, {
            to: "/home-about",
            target: "_blank",
            class: "menu-link px-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("About Us")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_router_link, {
            to: "/home-faq",
            target: "_blank",
            class: "menu-link px-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("FAQ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: "/contact",
            target: "_blank",
            class: "menu-link px-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Contact")
            ]),
            _: 1
          })
        ])
      ])
    ], 2)
  ]))
}